import {apiService} from '../apiService';
import type {PaginatedResponse, Payment, RecordPaymentRequest, UpdatePaymentRequest} from 'shared-types';

export const paymentApi = {
    // GET routes based on actual backend
    getAll: (): Promise<Payment[]> =>
        apiService.get('/payment'),

    getByPage: (page: number, limit: number): Promise<PaginatedResponse<Payment>> =>
        apiService.get(`/payment/by-page?page=${page}&limit=${limit}`),

    getById: (id: string): Promise<Payment> =>
        apiService.get(`/payment/id/${id}`),

    search: (text: string): Promise<Payment[]> =>
        apiService.get(`/payment/search?text=${text}`),

    // POST routes
    create: (payment: RecordPaymentRequest): Promise<Payment> =>
        apiService.post('/payment', payment),

    // PATCH routes
    update: (id: string, payment: UpdatePaymentRequest): Promise<Payment> =>
        apiService.patch(`/payment/${id}`, payment),

    // DELETE routes
    delete: (id: string): Promise<void> =>
        apiService.delete(`/payment/${id}`),
};